import { FunctionalComponent } from 'preact';

import { EmptyBlockProps } from './empty_block.types';

export const EmptyBlock: FunctionalComponent<EmptyBlockProps> = (props) => {
  const { id, widget_id: widgetId } = props;

  return <div id={`${id}_${widgetId}`} className="empty" />;
};
